// Funnel free-shipping reconciliation. Only runs for visitors carrying the
// auto-applied offer-page discount, and only once the cart clears its minimum.
(function () {
  var CODE = 'PARCELSHIP85', MIN = 8500, eligible = false, checked = false;
  if (document.cookie.indexOf('discount_code=' + CODE) === -1) return;
  function paint() {
    if (!checked || !eligible) return;
    var bars = document.querySelectorAll('.free-shipping-bar');
    for (var i = 0; i < bars.length; i++) {
      var el = bars[i];
      if (el.getAttribute('data-pp-fs') === '1') continue;
      el.setAttribute('data-pp-fs', '1');
      var s = el.querySelector('span');
      if (s) s.textContent = 'Free shipping applied to your order.';
      var b = el.querySelector('progress-bar');
      if (b) b.style.setProperty('--progress', '100%');
    }
  }
  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        eligible = c.items_subtotal_price >= MIN;
        checked = true;
        var done = document.querySelectorAll('.free-shipping-bar[data-pp-fs]');
        for (var i = 0; i < done.length; i++) done[i].removeAttribute('data-pp-fs');
        paint();
      })
      .catch(function () {});
  }
  refresh();
  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('click', function () { setTimeout(refresh, 900); }, true);
  if (window.MutationObserver) {
    new MutationObserver(paint).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
